var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-theme"},_vm._l((_vm.supportedThemes),function(themeName,key){return _c('sword-button-wuk',{key:key,attrs:{"text":themeName,"theme":"tertiary","disabled":_vm.isCurrentTheme(themeName)},nativeOn:{"click":function($event){return _vm.changeTheme(themeName)}}},[_vm._v(" "+_vm._s(themeName)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }